"use client"

import type { ReactNode } from "react"

import { TICARI_ILETI_ONAY_METNI } from "@/features/yasal"
import { Checkbox } from "@/shared/components/ui/checkbox"
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shared/components/ui/form"

function OnayKutusu({ name, children }: { name: string; children: ReactNode }) {
  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormItem className="gap-1.5">
          <div className="flex items-start gap-2.5">
            <FormControl>
              <Checkbox
                ref={field.ref}
                checked={Boolean(field.value)}
                onCheckedChange={(checked) => field.onChange(checked === true)}
                className="mt-0.5"
              />
            </FormControl>
            <FormLabel className="block text-xs leading-relaxed font-normal text-muted-foreground">
              {children}
            </FormLabel>
          </div>
          <FormMessage className="ps-6.5 text-xs" />
        </FormItem>
      )}
    />
  )
}

function BelgeBaglantisi({ onAc, children }: { onAc: () => void; children: ReactNode }) {
  return (
    <button
      type="button"
      className="font-medium text-foreground underline underline-offset-4"
      onClick={(event) => {
        // Etiketin içinde: tıklama kutucuğu da işaretlemesin.
        event.preventDefault()
        onAc()
      }}
    >
      {children}
    </button>
  )
}

interface KayitOnayAlanlariProps {
  onAydinlatmaAc: () => void
  onKosullarAc: () => void
}

/**
 * Kullanım koşulları (Ek-1 Veri İşleme Şartları dahil) bir sözleşme kabulüdür ve
 * Deneme Dönemi'ndeki veri işlemeyi de kapsar — kayıt buna bağlıdır. Aydınlatma bir
 * "rıza" değil bilgilendirmedir: zorunlu kutucuk yalnız okunduğunu teyit eder.
 * Ticari ileti onayı ayrı ve isteğe bağlıdır — kayıt ona bağlanmaz.
 */
export function KayitOnayAlanlari({ onAydinlatmaAc, onKosullarAc }: KayitOnayAlanlariProps) {
  return (
    <div className="space-y-3">
      <OnayKutusu name="kullanim_kosullari">
        <BelgeBaglantisi onAc={onKosullarAc}>Kullanım Koşulları ve Abonelik Sözleşmesi</BelgeBaglantisi>
        {" "}ile ekindeki Veri İşleme Şartları&apos;nı okudum, kabul ediyorum.
      </OnayKutusu>

      <OnayKutusu name="kvkk_aydinlatma">
        Kişisel verilerimin işlenmesine ilişkin{" "}
        <BelgeBaglantisi onAc={onAydinlatmaAc}>Aydınlatma Metni</BelgeBaglantisi>
        &apos;ni okudum.
      </OnayKutusu>

      <OnayKutusu name="ticari_ileti_onayi">
        {TICARI_ILETI_ONAY_METNI} <span className="text-foreground/70">(İsteğe bağlı)</span>
      </OnayKutusu>
    </div>
  )
}
